import { useMemo } from 'react'
import { useOptionalPartnerContext } from '@retailer-platform/dashboard/utils'
import { FeatureEntitlements } from '../../access-control/featureEntitlements'

/**
 * Checks if the current partner has the partner bulk delivery entitlement.
 *
 * Uses the partner context directly rather than useDomainAccessControl because
 * this is a partner-level entitlement. useDomainAccessControl resolves to
 * useAccessControl which prefers the warehouse context when a warehouse ID is
 * in the URL — and the warehouse context's featureEntitlements may not be
 * populated until the warehouse data fully loads, causing a delayed result.
 */
export const useIsPartnerBulkDeliveryEnabled = () => {
  const partnerContext = useOptionalPartnerContext()

  return useMemo(() => {
    if (!partnerContext?.loaded) {
      return false
    }

    return (
      partnerContext.featureEntitlements?.some(
        e => e.id === FeatureEntitlements.PartnerBulkDeliveryEnabled
      ) ?? false
    )
  }, [partnerContext])
}
